import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

var swiper = new Swiper('.article-swiper', {
  // Optional parameters
  direction: 'horizontal',
  spaceBetween: 32,
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
    1280: {
      slidesPerView: 4,
    },
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
});

var swiper = new Swiper('.red-flags-swiper', {
  // Optional parameters
  direction: 'horizontal',
  spaceBetween: 32,
  autoplay: true,
  speed: 1000,
  loop: true,
  //effect: 'fade',
  allowTouchMove: false,
});

var swiper = new Swiper('.home-hero-swiper', {
  // Optional parameters
  direction: 'horizontal',
  spaceBetween: 32,
  autoplay: true,
  speed: 1000,
  loop: true,
  //effect: 'fade',
  //allowTouchMove: false,
  pagination: {
    el: '.swiper-pagination',
  },
});
